import create from 'zustand';

type Profile = {
  name?: string;
  program?: 'plus' | 'young' | 'saga' | 'pb' | 'intro';
  avatarSrc?: string;
};

type DNBMenuStoreTypes = {
  profile: Profile;
  setProfile: (profile: Profile) => void;
};

export const useHeaderStore = create<DNBMenuStoreTypes>((set) => ({
  profile: {
    name: null,
    program: null,
    avatarSrc: null,
  },
  setProfile: (profile: Profile) => set({ profile }),
}));

export type { Profile, DNBMenuStoreTypes };
